import { addAminBonusApi, getAllUserByIdApi, getUserApi, getYoutubeUserApi, updateUserApi, blockUserApi, getUserWalletApi, exportUsersApi, updateRestrictApi, getUserStakingApi, getUserStakingTransactionsApi, getUserEtokenBalancesApi, getStakingTransactionsApi, getAllUsersListApi, getUserLevelsApi, getUsersWatchPointsHistoryApi, getUsersDailyBonusHistoryApi, getUserBonusListApi, logoutUserApi, logoutAllUsersApi } from "../components/constant/Api";
import { myApi } from "./api";

export const userApi = myApi.injectEndpoints({
  endpoints: (builder) => ({

    getUser: builder.query({
      query: (params) => {
        const queryString = params ? "?" + new URLSearchParams(params).toString() : "";
        return {
          url: getUserApi + queryString,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => {
        return response.status ? response : { data: [], total: 0 };
      },
      providesTags: (_) => ["user"],
    }),
    getUserLevels: builder.query({
      query: (params) => {
        const queryString = params ? "?" + new URLSearchParams(params).toString() : "";
        return {
          url: getUserLevelsApi + queryString,
          method: "GET",
        };
      },
    }),
    setAddAminBonus: builder.mutation({
      query: (post) => ({
        url: addAminBonusApi,
        method: "POST",
        body: post
      }),
      invalidatesTags: (_) => ["transaction"],
    }),
    getYoutubeUSer: builder.query({
      query: (post) => ({
        url: getYoutubeUserApi,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? [] : [];
      },
      providesTags: (_) => ["user"],
    }),
    getAllUserById: builder.mutation({
      query: (post) => ({
        url: getAllUserByIdApi,
        method: "POST",
        body: post
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? [] : [];
      },
      providesTags: (_) => ["user"],
    }),
    updateUser: builder.mutation({
      query: (post) => ({
        url: updateUserApi,
        method: "POST",
        body: post
      }),
      invalidatesTags: (_) => ["user"],
    }),
    blockUser: builder.mutation({
      query: (post) => ({
        url: blockUserApi,
        method: "POST",
        body: post
      }),
      invalidatesTags: (_) => ["user"],
    }),
    getUserWallet: builder.mutation({
      query: (post) => ({
        url: getUserWalletApi,
        method: "POST",
        body: post
      }),
    }),
    exportUsers: builder.mutation({
      query: () => ({
        url: exportUsersApi,
        method: "GET"
      }),
    }),
    updateRestrict: builder.mutation({
      query: (post) => ({
        url: updateRestrictApi,
        method: "POST",
        body: post
      }),
      invalidatesTags: (_) => ["user"],
    }),
    getUserStaking: builder.query({
      query: (params) => {
        const activeParams = {};
        for (const key in params) {
            if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
                activeParams[key] = params[key];
            }
        }
        const queryString = Object.keys(activeParams).length > 0 ? "?" + new URLSearchParams(activeParams).toString() : "";
        return {
          url: getUserStakingApi + queryString,
          method: "GET"
        };
      },
    }),

    getUserStakingTransactions: builder.query({
      query: (params) => {
        const queryString = params ? "?" + new URLSearchParams(params).toString() : "";
        return {
          url: getUserStakingTransactionsApi + queryString,
          method: "GET"
        };
      },
    }),

    getUserEtokenBalances: builder.query({
      query: (params) => {
        // filter out empty params to not send empty search queries
        const activeParams = {};
        for (const key in params) {
            if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
                activeParams[key] = params[key];
            }
        }
        const queryString = Object.keys(activeParams).length > 0 ? "?" + new URLSearchParams(activeParams).toString() : "";
        return {
          url: getUserEtokenBalancesApi + queryString,
          method: "GET"
        };
      },
    }),

    getStakingTransactions: builder.query({
      query: (params) => {
        const activeParams = {};
        for (const key in params) {
            if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
                activeParams[key] = params[key];
            }
        }
        const queryString = Object.keys(activeParams).length > 0 ? "?" + new URLSearchParams(activeParams).toString() : "";
        return {
          url: getStakingTransactionsApi + queryString,
          method: "GET"
        };
      },
    }),

    getAllUsersList: builder.query({
      query: () => ({
        url: getAllUsersListApi,
        method: "GET"
      }),
    }),
    getUsersWatchPointsHistory: builder.query({
      query: (params) => {
        const activeParams = {};
        for (const key in params) {
            if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
                activeParams[key] = params[key];
            }
        }
        const queryString = Object.keys(activeParams).length > 0 ? "?" + new URLSearchParams(activeParams).toString() : "";
        return {
          url: getUsersWatchPointsHistoryApi + queryString,
          method: "GET"
        };
      },
    }),
    getUsersDailyBonusHistory: builder.query({
      query: (params) => {
        const activeParams = {};
        for (const key in params) {
            if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
                activeParams[key] = params[key];
            }
        }
        const queryString = Object.keys(activeParams).length > 0 ? "?" + new URLSearchParams(activeParams).toString() : "";
        return {
          url: getUsersDailyBonusHistoryApi + queryString,
          method: "GET"
        };
      },
    }),
    getUserBonusList: builder.query({
      query: (params) => {
        const activeParams = {};
        for (const key in params) {
            if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
                activeParams[key] = params[key];
            }
        }
        const queryString = Object.keys(activeParams).length > 0 ? "?" + new URLSearchParams(activeParams).toString() : "";
        return {
          url: getUserBonusListApi + queryString,
          method: "GET"
        };
      },
    }),

    logoutUser: builder.mutation({
      query: (post) => ({
        url: logoutUserApi,
        method: "POST",
        body: post,
      }),
    }),

    logoutAllUsers: builder.mutation({
      query: () => ({
        url: logoutAllUsersApi,
        method: "POST",
      }),
    }),

  }),
});

export const { useGetUserQuery, useSetAddAminBonusMutation, useGetYoutubeUSerQuery, useGetAllUserByIdMutation, useUpdateUserMutation, useBlockUserMutation, useGetUserWalletMutation, useExportUsersMutation, useUpdateRestrictMutation, useGetUserStakingQuery, useLazyGetUserStakingTransactionsQuery, useGetUserEtokenBalancesQuery, useGetStakingTransactionsQuery, useLazyGetStakingTransactionsQuery, useGetAllUsersListQuery, useLazyGetUserLevelsQuery, useGetUsersWatchPointsHistoryQuery, useGetUsersDailyBonusHistoryQuery, useGetUserBonusListQuery, useLazyGetUserBonusListQuery, useLogoutUserMutation, useLogoutAllUsersMutation } = userApi;